<template>
  <div class="auction-page">
    <AuctionHeader v-if="auction" />

    <AuctionGrid
      @bid="handleBid"
    />

    <div class="pagination-controls">
      <div class="pagination-pages" v-if="auction?.totalGroups > 1">
        <div
          class="page-btn prev-btn "
          @click="goToGroup(Math.max(1, (auction?.currentGroup || 1) - 1))"
        >
          Հետ
        </div>
        <button
            v-for="page in auction?.totalGroups"
            :key="page"
            @click="goToGroup(page)"
            :class="['page-btn', { active: auction?.currentGroup == page }]"
        >
          {{ page }}
        </button>
        <div class="page-btn next-btn" @click="goToGroup(Math.min(auction?.totalGroups, (auction?.currentGroup || 1) + 1))">Առաջ</div>
      </div>
    </div>

  </div>
</template>

<style lang="scss">
@import '@/assets/styles/auction.scss';
</style>

<script>
import { auctionSocketMixin } from '@/mixins/auctionSocketMixin'
import auction from "@/mixins/auction";
import AuctionHeader from '@/components/auction/AuctionHeader.vue'
import AuctionGrid from '@/components/auction/AuctionGrid.vue'

export default {
  components: { AuctionHeader, AuctionGrid },
  mixins: [auctionSocketMixin, auction],
  data() {
    return {}
  },
  computed: {
    me() {
      return this.$store.getters['user/me']
    },
    activeAuctions() {
      return this.$store.getters['auction/activeAuctions'];
    },
    auctionCount() {
      return this.$store.getters['auction/auctionCount'];
    },
    hasAuctions() {
      return this.$store.getters['auction/hasAuctions'];
    },
    getAuctionById() {
      return this.$store.getters['auction/getAuctionRowById'];
    },
    auction() {
      return this.$store.getters['auction/auction'];
    },
  },
  watch: {
    me(newMe) {
      this.connectSocket();
    }
  },
  methods: {
    showToast(msg, type) {
      this.$fire({ text: msg, type: type })
    },
    async handleBid(bidData) {
      const { auctionRowId, amount } = bidData

      const auction = this.getAuctionById(auctionRowId)

      if (!auction || auction.status !== this.auctionRowStatus.ONGOING) {
        this.showToast('Աճուրդը վերջացել է', 'error')
        return
      }

      const minRequired = auction.currentPrice + auction.minIncrement
      if (amount < minRequired) {
        this.showToast(`Նվազագույն առաջարկը ${minRequired}`, 'error')
        return
      }

      // Try socket emit first
      this.emitBid(auctionRowId, amount)
    },
    goToGroup(page = 1) {
      this.emitPage(page)
    },
    connectSocket() {
      if (this.me.id) {
        const token = localStorage.getItem("accessToken");
        this.initSocket(`${process.env.VUE_APP_SOCKET_URL}/?type=auction&auction_id=${this.$route.params.id}&token=${token}`)
      }
    }
  },
  mounted() {
    this.connectSocket()
  },
}
</script>
